import gql from 'graphql-tag';

export default gql`
  mutation UpdatePropertyDocument($id: ID!, $status: DocumentStatus, $name: String) {
    updateDocument(id: $id, data: { status: $status, name: $name }) {
      createdAt
      id
      updatedAt
      status
      name
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdatePropertyDocument.ts